import { PassoDoTutorial, Tutorial } from '../tutorial.model';

const INFORMACAO: PassoDoTutorial = {
  alvo: 'lp-cadastro.informacao',
  aba: 'lp-cadastro.informacao',
  titulo: 'O que você organiza neste cadastro',
  corpo: 'A conta contábil identifica a natureza contábil do que você paga ou recebe, como Energia elétrica. Nesta aba ficam sua identificação e os vínculos com categorias gerenciais, usadas para organizar as finanças da empresa.',
};

const PASSOS_COMUNS: readonly PassoDoTutorial[] = [
  {
    alvo: 'lp-cadastro.nome',
    aba: 'lp-cadastro.informacao',
    titulo: 'Nome da natureza da conta',
    corpo: 'Use o nome da conta contábil, como Energia elétrica. Nomes de fornecedores, como Cemig ou Enel, podem entrar como apelidos na aba Aliases para facilitar a busca.',
  },
  {
    alvo: 'lp-cadastro.codigo',
    aba: 'lp-cadastro.informacao',
    titulo: 'Código que identifica a conta contábil',
    corpo: 'Este é o identificador da conta contábil no plano de contas. Ao criar uma conta contábil, informe um código numérico disponível no mesmo tipo. As contas contábeis do modelo já vêm com códigos preenchidos; você pode mantê-los.',
  },
  {
    alvo: 'lp-cadastro.categorias',
    aba: 'lp-cadastro.informacao',
    titulo: 'Vincule a organização gerencial',
    corpo: 'Selecione uma ou mais categorias para usar esta conta contábil nas contas. Por exemplo, Energia elétrica pode estar ligada a Despesas administrativas. A busca mostra categorias do mesmo tipo, pagar ou receber. Marcar adiciona um vínculo; desmarcar o remove ao salvar. Os vínculos do modelo já vêm preparados.',
  },
  {
    alvo: 'lp-cadastro.aliases',
    aba: 'lp-cadastro.aliases',
    titulo: 'Aliases são apelidos para encontrar a conta contábil',
    corpo: 'Esta aba reúne os termos pelos quais você costuma procurar a conta. Para Energia elétrica, por exemplo, Cemig, Copel ou Enel ajudam a localizar a mesma conta contábil sem mudar seu nome contábil.',
  },
  {
    alvo: 'lp-cadastro.apelidos',
    aba: 'lp-cadastro.aliases',
    titulo: 'Adicione os termos usados na sua rotina',
    corpo: 'Use Adicionar alias e escreva um apelido em cada campo, com pelo menos três caracteres. O botão de lixeira remove aquele apelido. Preencha os campos adicionados ou remova os que não vai usar; as mudanças são gravadas com Salvar.',
  },
  {
    alvo: 'lp-cadastro.voltar',
    titulo: 'Volte à listagem quando quiser',
    corpo: 'Voltar abre a lista de contas contábeis sem salvar as alterações deste formulário. Se estiver apenas conhecendo a tela, você pode voltar e continuar o roteiro sem mudar o cadastro.', corpoManual: 'Voltar abre a lista de contas contábeis sem salvar as alterações deste formulário.',
  },
  {
    alvo: 'lp-cadastro.salvar',
    aba: 'lp-cadastro.informacao',
    titulo: 'Grave as alterações do cadastro',
    corpo: 'Salvar grava a identificação, os vínculos com categorias e os apelidos. Corrija os campos sinalizados, se houver. Encerrar este guia não salva nem altera a conta contábil; use o botão quando quiser aplicar suas mudanças.', corpoBase: 'Salvar grava a identificação, os vínculos com categorias e os apelidos. Corrija os campos sinalizados, se houver. A conta contábil só muda depois de Salvar.',
  },
];

export const LP_CADASTRO_TOUR: Tutorial = {
  id: 'lp-cadastro',
  rota: '/painel/lancamento-contabil/novo',
  passos: [
    INFORMACAO,
    {
      alvo: 'lp-cadastro.tipo',
      aba: 'lp-cadastro.informacao',
      titulo: 'Comece pelo tipo',
      corpo: 'Escolha Contas a pagar para saídas ou Contas a receber para entradas. Essa escolha define onde a conta contábil será usada e quais categorias podem ser vinculadas. Se trocar o tipo durante o cadastro, selecione novamente as categorias.',
    },
    ...PASSOS_COMUNS,
  ],
};

export const LP_EDICAO_TOUR: Tutorial = {
  id: 'lp-edicao',
  rota: '/painel/lancamento-contabil/editar/:id',
  passos: [
    INFORMACAO,
    {
      alvo: 'lp-cadastro.tipo',
      aba: 'lp-cadastro.informacao',
      titulo: 'Confira onde esta conta contábil é usada',
      corpo: 'O tipo identifica Contas a pagar ou Contas a receber e fica bloqueado na edição. As categorias oferecidas pertencem a esse mesmo tipo. Para cadastrar uma conta contábil do outro tipo, use Adicionar na listagem.',
    },
    ...PASSOS_COMUNS,
  ],
};
